import { JobOptionSvc, JobOptionSvcGroup } from 'domains/jobconfigDomain';
import React from 'react';
import { useRole } from 'hooks';
import ConfigSvcDetail from '.';
import RevxSvcContent from './RevxSvcContent';

type Props = {
  svcGroup?: JobOptionSvcGroup;
};

const AnyOfSvcs = ({ svcGroup, ...props }: Props) => {
  const { buyerRole } = useRole();

  const visibleSvcs =
    svcGroup?.svcs?.filter((svc) => {
      return !(buyerRole && svc.name === 'File Prep /per hr.');
    }) || [];

  return (
    <>
      {visibleSvcs?.map((svc: JobOptionSvc, index: number) => (
        <React.Fragment key={`${svc.revxTypeId}-${svc.revxId}-${index}`}>
          <ConfigSvcDetail
            {...svc}
            {...props}
            isRequired={svcGroup.isRequired}
            jobOptionSvc={svc}
          />
        </React.Fragment>
      ))}
      {Boolean(svcGroup?.svcGroups.length) && (
        <RevxSvcContent svcGroups={svcGroup?.svcGroups} {...props} />
      )}
    </>
  );
};

export default AnyOfSvcs;
